"use client";

import React, { MutableRefObject } from "react";
import Slider from "react-slick";
import { useMediaQuery } from "@/hook/use-media-query";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ProductDetailsResponse } from "@/types/product";
import { ProductCardUI } from "../product-card/product-card-ui";

interface Props {
  data: ProductDetailsResponse[];
  sliderRef: MutableRefObject<Slider | null>;
}

export const FeatureProductsMobile = ({ data, sliderRef }: Props) => {
  const md = useMediaQuery("(min-width: 768px)");

  const settings = {
    dots: false,
    infinite: data.length > 3,
    speed: 500,
    slidesToShow: (md && 2) || 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="lg:hidden justify-center">
      <Slider
        {...settings}
        ref={sliderRef}
        className="flex flex-row   justify-center cursor-pointer hover:cursor-pointer"
      >
        {data.map((product) => (
          <ProductCardUI
            product={product}
            pageType="featureProducts"
            key={product.id}
          />
        ))}
      </Slider>
    </div>
  );
};
